import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ClientReceivedDocument } from '../../domain/models/client-received-document.model';
import { IClientDocumentsRepository } from '../../domain/repositories/client-documents.repository';
import { ClientDocumentsRemoteDatasource } from '../datasources/remote/client-documents.remote-datasource';
import { ClientReceivedDocumentMapper } from '../mappers/client-received-document.mapper';

@Injectable()
export class ClientDocumentsRepositoryImpl implements IClientDocumentsRepository {
  private readonly datasource = inject(ClientDocumentsRemoteDatasource);
  private readonly mapper = inject(ClientReceivedDocumentMapper);

  public list(organizationId: number, recipientClientId: string): Observable<readonly ClientReceivedDocument[]> {
    return this.datasource.list(organizationId, recipientClientId).pipe(
      map((dtos) => dtos.map((dto) => this.mapper.toClientReceivedDocument(dto))),
    );
  }

  public upload(organizationId: number, recipientClientId: string, file: File): Observable<ClientReceivedDocument> {
    return this.datasource.upload(organizationId, recipientClientId, file).pipe(
      map((dto) => this.mapper.toClientReceivedDocument(dto)),
    );
  }

  public remove(organizationId: number, documentId: number): Observable<void> {
    return this.datasource.remove(organizationId, documentId);
  }
}
